export enum Status {
  CART = 1,
  ORDER = 2,
  FULFILLED = 3,
  CANCELLED = 4
}